import { UAParser } from "ua-parser-js";

export async function getClientInfo(otp) {
  // 2. Get IP address (from a public API)
  let ip_address = "";
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    ip_address = data.ip;
  } catch (error) {
    console.log("Error fetching IP:", error);
  }

  // 3. Get Device / OS / Browser from UA
  const parser = new UAParser(window.navigator.userAgent);
  const device = parser.getDevice().type || "desktop";
  const os = parser.getOS().name?.toLowerCase() || "unknown";
  const browser = parser.getBrowser().name?.toLowerCase() || "unknown";

  // 4. Raw headers are only available server-side
  const raw_header = window.navigator.userAgent;

  return {
    otp,
    ip_address,
    device,
    os,
    browser,
    raw_header,
  };
}
